/**
 * Presentation for the markdown adapter, kept out of the component files so
 * each override stays inside the 50-line cap and the visual language lives in
 * one place. Values reference the Stage 1 tokens.
 */
export const HEADING_SX = {
  2: { fontSize: 'var(--app-agent-result-title-size)', mt: 1.5, mb: 0.75 },
  3: { fontSize: 'var(--app-agent-result-title-size)', mt: 1.25, mb: 0.5 },
  4: { fontSize: 'var(--app-agent-result-title-size)', mt: 1, mb: 0.5 },
}

export const headingSx = (level) => ({
  m: 0,
  fontFamily: 'var(--app-font-display)',
  fontWeight: 'var(--app-agent-result-font-weight-medium)',
  lineHeight: 'var(--app-agent-result-line-height)',
  color: 'var(--app-text-primary)',
  ...(HEADING_SX[level] ?? HEADING_SX[4]),
})

export const paragraphSx = { m: 0, font: 'inherit', color: 'var(--app-text-primary)' }

export const listSx = {
  my: 0.25,
  pl: 2.5,
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  font: 'inherit',
}

export const blockquoteSx = {
  m: 0,
  pl: 1.5,
  borderLeft: '3px solid var(--app-response-rule)',
  color: 'var(--app-text-secondary)',
  font: 'inherit',
}

export const tableSx = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: 'var(--app-agent-result-font-size, 13px)',
  lineHeight: 'var(--app-agent-result-line-height, 1.2)',
  '& th, & td': { textAlign: 'left', px: 1.75, py: 1.25, verticalAlign: 'top', borderBottom: '1px solid var(--app-border-light)', fontSize: 'var(--app-agent-result-font-size, 13px)' },
  '& thead th': {
    bgcolor: 'var(--app-bg-hover)',
    borderBottom: '1px solid var(--app-border-light)',
    fontWeight: 500,
    color: 'var(--app-text-primary)',
    whiteSpace: 'nowrap',
  },
  '& tbody td': { bgcolor: 'var(--app-bg-panel)', color: 'var(--app-text-secondary)' },
  '& tbody tr:last-of-type td': { borderBottom: 'none' },
}

/** Wide tables scroll inside their own box; the thread column must not. */
export const tableWrapSx = { width: '100%', overflowX: 'auto', border: '1px solid var(--app-border-light)', borderRadius: 'var(--app-radius-md)', bgcolor: 'var(--app-bg-panel)', overflow: 'hidden' }

export const hrSx = { border: 0, borderTop: '1px solid var(--app-response-rule)', my: 1.5 }
